import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({
  baseURL: API,
  headers: { "Content-Type": "application/json" },
  withCredentials: true,
});

export function setAdminToken(token) {
  if (token) {
    localStorage.setItem("sb_admin_token", token);
  } else {
    localStorage.removeItem("sb_admin_token");
  }
}

export function getAdminToken() {
  return localStorage.getItem("sb_admin_token");
}

export function adminAuthHeader() {
  const token = getAdminToken();
  return token ? { Authorization: `Bearer ${token}` } : {};
}
